import styles from './CodeViewSidebar.module.css'

/**
 * Layout container for the repository sidebar.
 * Renders the grid shell without requiring all section data upfront,
 * allowing each child section to be independently wrapped in Suspense.
 */
export function CodeViewSidebarLayout({children}: {children: React.ReactNode}) {
  return <div className={styles.borderGrid}>{children}</div>
}
